import styled from "styled-components";
import FormularioDados from "./FormularioDados";
import FormularioAlojamento from "./FormularioAlojamento";
import FormularioLocacao from "./FormularioLocacao";
import ContainerFolgaCampo from "./ContainerFolgaCampo";

const Container = styled.div`
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE e Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari */
    }
`

const ContainerFormularios = ({ data, fetchData, folgasCampo, protheus }) => {
    return (
        <>
            <Container>
                <FormularioDados data={data} fetchData={fetchData} />
                {data?.hospedagem === 'ALOJADO' && (
                    <FormularioAlojamento data={data} fetchData={fetchData} />
                )}
                {data?.locado && (
                    <FormularioLocacao data={data} fetchData={fetchData} />
                )}
                <ContainerFolgaCampo
                    folgasCampo={folgasCampo}
                    fetchData={fetchData}
                    protheus={protheus}
                />
            </Container>
        </>
    )
}

export default ContainerFormularios;